import { render } from "./WhatIsVideoScreen.vue?vue&type=template&id=38b017b5&scoped=true"
import script from "./WhatIsVideoScreen.vue?vue&type=script&lang=js"
export * from "./WhatIsVideoScreen.vue?vue&type=script&lang=js"

import "./WhatIsVideoScreen.vue?vue&type=style&index=0&id=38b017b5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b017b5"]])

export default __exports__